angular.module("events_users_profiles")

    .controller("EventsUsersProfilesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$q', 'treeService', '$timeout', '$uibModal', function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $q, treeService, $timeout, $uibModal) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_USERS_PROFILES_WRITE");
        $rootScope.title = $filter('translate')('events_users_profiles.title');

        $scope.event_user_profile = {};
        $scope.menusItems = []
        $scope.view = [];
        $scope.edit = [];

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events_users_profiles.title'), url: "events_users_profiles.list" },
                { title: $filter('translate')('events_users_profiles.title_add') },
            ];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events_users_profiles.title'), url: "events_users_profiles.list" },
                { title: $filter('translate')('events_users_profiles.title_edit') },
            ];

            Restangular.one('EventsUsersProfiles', $stateParams.id).get().then(function (result) {
                $scope.event_user_profile = result;
            });
        }

        $scope.loadMenu = function () {
            //Cargar los nodos del menú de eventos
            Restangular.all('Menus').getList({ code: 'EVENT_MENU' }).then(function (results) {
                $scope.menu = results;
                var options = { menu_id: $scope.menu[0].id, _sortBy: "position", _sortDirection: "asc" };
                Restangular.all('MenusItems').getList(options).then(function (results) {
                    var menusItems = [];
                    menusItems = treeService.menuTree(results, null, menusItems);
                    //$scope.menusItems = [];
                    var idxParent;
                    angular.forEach(menusItems, function (menuItem, idx) {
                        if (menuItem.parent_menu_item_id == null) {
                            menuItem.childs = [];
                            $scope.menusItems.push(menuItem);
                            idxParent = $scope.menusItems.length - 1;
                        } else {
                            if (angular.isDefined(idxParent)) {
                                $scope.menusItems[idxParent].childs.push(menuItem);
                            }
                        }
                    });
                    $scope.$emit("loadPermissions", {});
                });
            });
        };
        $scope.loadMenu();

        $scope.$on("loadPermissions", function () {
            $scope.loadPermissions();
        });

        $scope.loadPermissions = function () {
            $scope.permissions = $scope.event_user_profile.FK_events_users_profiles_menus_items_permissions_events_users_profiles;
            var viewsFilter = $scope.permissions.filter(function (el) { return el.permission == 'view'; });
            angular.forEach(viewsFilter, function (prm) {
                angular.forEach($scope.menusItems, function (itm) {
                    if (prm.menu_item_id === itm.id) {
                        $scope.view[itm.id] = "true";
                    }
                });
            });
            var editsFilter = $scope.permissions.filter(function (el) { return el.permission == 'edit'; });
            angular.forEach(editsFilter, function (prm) {
                angular.forEach($scope.menusItems, function (itm) {
                    if (prm.menu_item_id === itm.id) {
                        $scope.edit[itm.id] = "true";
                    }
                });
            });
        };

        $scope.saveEventUserProfile = function () {
            var viewItems = [];
            var editItems = [];
            for (var v = 0; v < $scope.view.length; v++) {
                if (angular.isDefined($scope.view[v]) && $scope.view[v] === "true") {
                    viewItems.push(v);
                }
            }
            for (var e = 0; e < $scope.edit.length; e++) {
                if (angular.isDefined($scope.edit[e]) && $scope.edit[e] === "true") {
                    editItems.push(e);
                }
            }

            if (angular.isDefined($scope.event_user_profile.id)) {
                $scope.event_user_profile.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        Restangular.all('EventsUsersProfiles').customPOST({}, "UpdateProfilePermissions", { profile_id: result.id, view_permissions: viewItems.toString(), edit_permissions: editItems.toString() }).then(function (result) {
                            toastr.success($filter('translate')('events_users_profiles.edit_success'));
                            $state.go("events_users_profiles.list");
                        });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('EventsUsersProfiles').post($scope.event_user_profile).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        Restangular.all('EventsUsersProfiles').customPOST({}, "UpdateProfilePermissions", { profile_id: result.id, view_permissions: viewItems.toString(), edit_permissions: editItems.toString() }).then(function (result) {
                            toastr.success($filter('translate')('events_users_profiles.save_success'));
                            $state.go("events_users_profiles.list");
                        });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('events_users_profiles.button_delete'),
                message: $filter('translate')('events_users_profiles.delete_message') + " " + $scope.event_user_profile.name + "?",
                onAccept: function () {
                    $scope.event_user_profile.remove().then(function () {
                        toastr.success($filter('translate')('events_users_profiles.deleted_success'));
                        $state.go("events_users_profiles.list");
                    });
                }
            });
        };
    
}])

;

